import types from 'actions/Types';

// Thunk Middleware
const logger = store => next => action => {
    const state = store.getState();
    switch (action.type) {
        case types.STORE_SEARCH:
            window.dataLayer.push({
                event: 'Store Locator',
                category: 'Store Locator',
                action: action.action,
                label: action.label
            });
            break;
        case types.AVAILABILITY:
            window.dataLayer.push({
                event: 'Product',
                category: 'Product Inventory Availability',
                action: 'Show',
                label: action.data
            });
            break;
    }
    return next(action);
};

export default logger;
